import React from "react";
import PropTypes from "prop-types";
import Translate from "react-translate-component";
import ReactTooltip from "react-tooltip";
import Icon from "../Icon/Icon";
import { Download } from "../Wallet/Backup";

class WalletRegistrationConfirm extends React.Component {
  static propTypes = {
    toggleConfirmed: PropTypes.func.isRequired,
    checkboxUploaded: PropTypes.bool.isRequired,
    checkboxRecover: PropTypes.bool.isRequired,
    checkboxRemember: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired
  };
  onBackupDownload = () => {
    this.props.history.push("/");
  };

  static renderWarning() {
    return /*#__PURE__*/React.createElement("div", {
      className: "attention-note"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "attention",
      size: "1x"
    }), /*#__PURE__*/React.createElement(Translate, {
      content: "registration.attention",
      className: "attention-text"
    }), /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      content: "registration.walletNote"
    }));
  }

  renderTooltip() {
    return /*#__PURE__*/React.createElement(ReactTooltip, {
      id: "wallet-confirm",
      className: "custom-tooltip text-left",
      globalEventOff: "click"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tooltip-text",
      onClick: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement(Translate, {
      content: "tooltip.registration.whyBinFile"
    }), /*#__PURE__*/React.createElement("span", {
      onClick: () => ReactTooltip.hide(),
      className: "close-button cursor-pointer"
    }, "\xD7")));
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "text-left"
    }, /*#__PURE__*/React.createElement("div", {
      className: "confirm-checks"
    }, /*#__PURE__*/React.createElement(Translate, {
      component: "h3",
      content: "registration.createAccountTitle"
    }), WalletRegistrationConfirm.renderWarning()), /*#__PURE__*/React.createElement("div", {
      className: "checkbox-block",
      onClick: () => this.props.toggleConfirmed("checkboxRemember")
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
      className: `${this.props.checkboxRemember ? "checkbox-active" : ""} checkbox`,
      name: "checkmark"
    })), /*#__PURE__*/React.createElement(Translate, {
      className: "checkbox-text",
      content: "registration.checkboxRemember"
    })), /*#__PURE__*/React.createElement("div", {
      className: "checkbox-block",
      onClick: () => this.props.toggleConfirmed("checkboxUploaded")
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
      className: `${this.props.checkboxUploaded ? "checkbox-active" : ""} checkbox`,
      name: "checkmark"
    })), /*#__PURE__*/React.createElement(Translate, {
      className: "checkbox-text",
      content: "registration.checkboxUploaded"
    })), /*#__PURE__*/React.createElement("div", {
      className: "checkbox-block",
      onClick: () => this.props.toggleConfirmed("checkboxRecover")
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
      className: `${this.props.checkboxRecover ? "checkbox-active" : ""} checkbox`,
      name: "checkmark"
    })), /*#__PURE__*/React.createElement(Translate, {
      className: "checkbox-text",
      content: "registration.checkboxRecover"
    })), /*#__PURE__*/React.createElement(Download, {
      confirmation: true,
      checkboxActive: this.props.checkboxUploaded && this.props.checkboxRemember && this.props.checkboxRecover,
      downloadCb: this.onBackupDownload
    }), /*#__PURE__*/React.createElement(Translate, {
      component: "p",
      className: "cursor-pointer why-bin-file checkbox-text",
      content: "registration.whyBinFile",
      "data-for": "wallet-confirm",
      "data-tip": true,
      "data-event": "click",
      "data-place": "bottom",
      "data-effect": "solid"
    }), this.renderTooltip());
  }

}

export default WalletRegistrationConfirm;